export default "__VITE_ASSET__CglQ$psE__"